// extracted by mini-css-extract-plugin
module.exports = {"form-container":"dd31006766--form-container--2L_VE","title-container":"dd31006766--title-container--hSdcz"};